import React from "react";
import PublicIcon from "@mui/icons-material/Public";
import FormValidation from "../../components/FormValidation/FormValidation";
import formFields from "../../config/formFields.json";

const AddClientPoc = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  clients = [],
  countries = [],
}) => {
  const isEdit = !!initialData;
  console.log("initialDatainitialData", initialData);
  const initialValues = {
    client_id: initialData?.client_id?.toString() || null,
    poc_name: initialData?.poc_name || "",
    poc_designation: initialData?.poc_designation || "",
    poc_mobile: initialData?.poc_mobile || "",
    poc_email: initialData?.poc_email || "",
    poc_business_unit: initialData?.poc_business_unit || "",
    country_id: initialData?.country_id?.toString() || "",
    is_active: initialData?.is_active ?? true,
  };

  const getOptionsForField = (fieldName) => {
    switch (fieldName) {
      case "client_id":
        return clients.map((client) => ({
          value: client.client_id.toString(),
          label: client.client_name,
        }));
      case "countries":
        return countries.map((country) => ({
          value: country.country_id.toString(),
          label: country.country_name,
        }));
      default:
        return [];
    }
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      getOptionsForField={getOptionsForField}
      formFields={formFields.client_poc.basic.fields}
      title="Client Poc"
      icon={PublicIcon}
      isEdit={isEdit}
      modelWidth="40vw"
    />
  );
};

export default AddClientPoc;
